const abi = [
  {
    type: 'function',
    name: 'lastDepositTime',
    inputs: [
      { name: '', type: 'address', internalType: 'address' },
      { name: '', type: 'address', internalType: 'address' },
    ],
    outputs: [{ name: '', type: 'uint256', internalType: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'deposit',
    inputs: [
      { name: 'token', type: 'address', internalType: 'address' },
      { name: 'amount', type: 'uint256', internalType: 'uint256' },
    ],
    outputs: [],
    stateMutability: 'payable',
  },
  {
    inputs: [
      { internalType: 'address', name: 'token', type: 'address' },
      { internalType: 'uint256', name: 'amount', type: 'uint256' },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
    name: 'withdraw',
  },
  {
    inputs: [
      { internalType: 'address', name: '', type: 'address' },
      { internalType: 'address', name: '', type: 'address' },
    ],
    stateMutability: 'view',
    type: 'function',
    name: 'balances',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
  },
] as const

const address = '0xB96c805C65e2A4CA290f5B7e8e3dE1aE08071265' as `0x${string}`

export const cncStakingContractConfig = {
  address,
  abi,
} as const

export const cncTokenAddress = '0xD3844AcCa3562b52a22e46fb56C5c29b621b0d33'
export const abstractChainId = 2741
export const abstractExplorerUrl = 'https://abscan.org/'
